<template>
  <section class="mb-8 mt-16 md:mt-8 font-arial mx-auto max-w-[1400px]">
    <section
      class="my-8 bg-black pt-6 px-2 md:px-10 pb-5 font-bold shadow-black shadow-xl"
    >
      <RallyLogoDownload />
      <h1 class="font-russo text-3xl text-white pt-12 pb-4">
        Upgrade Successful
      </h1>
      <h2 class="font-russo text-2xl text-white pb-12">
        Please Restart Rally Navigator
      </h2>
    </section>
    <PartnersSmall />
    <RallyLogoDownload link-text="Download Rally Navigator" />
  </section>
</template>

<script>
import PartnersSmall from './PartnersSmall.vue';
import RallyLogoDownload from './RallyLogoDownload.vue';
import { trackPurchase } from '../analytics';

export default {
  name: 'UpgradeSucceeded',
  components: {
    PartnersSmall,
    RallyLogoDownload,
  },
  mounted() {
    const { plan, session_id: transactionId } = this.$route.query;
    trackPurchase({ plan, transactionId });
  },
};
</script>

<style scoped></style>
